import { html, utl_renderObjects, utl_fadeIn, utl_handleModalClose } from "../base/_utils";
import { staff } from "../data/_staff";
import staffCard from "../components/templates/_staff-card";
import execStaffCard from "../components/templates/_exec-staff-card";
import { execCommittee } from "../data/_executive-committee";

/* ******************** RENDER STAFF CARDS / MODALS ******************** */
utl_renderObjects({
    data: staff,
    template: (member) => html`<div class="col mb-4">${staffCard(member, "../")}</div>`,
    target: "#staff-container",
});

utl_renderObjects({
    data: execCommittee,
    template: (member) => html`<div class="col mb-4">${execStaffCard(member, "../")}</div>`,
    target: "#exec-committee-container",
});

document.querySelectorAll(".staff-modal").forEach((modal) => {
    document.querySelector("body").prepend(modal);
});

utl_fadeIn();
utl_handleModalClose();
